// extracted by mini-css-extract-plugin
export default {"wrapper":"RightSide_wrapper__aMAwJ","img":"RightSide_img__AC6rN"};